import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-user-active-modal',
  templateUrl: './user-active-modal.component.html',
  styleUrls: ['./user-active-modal.component.css']
})
export class UserActiveModalComponent implements OnInit {
  @Input() public user: any;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {}

}
